var _sdk = null;

export default {
  set: function (sdk) {
    // console.log('set sdk:', sdk);
    _sdk = sdk;
  },
  get: function () {
    // console.log('get sdk:', _sdk);
    return _sdk;
  }
};
